import { matchLanguage } from "./languages.js";
export const LANGUAGE_COOKIE = "tikl";
const ONE_YEAR_SECONDS = 365 * 24 * 60 * 60;
function isHostOnly(hostname) {
    return hostname === "localhost" || hostname.endsWith(".localhost") || /^[\d.]+$/.test(hostname) || hostname.includes(":");
}
/**
 * Set on the registrable domain (`apps.tickaroo.com` → `tickaroo.com`), so the apex and every tenant
 * host read one choice. `localhost` refuses a parent `Domain`, and Safari refuses `Secure` over http.
 */
export function languageCookie(tag, place) {
    const parts = [`${LANGUAGE_COOKIE}=${encodeURIComponent(tag)}`];
    if (!isHostOnly(place.hostname)) {
        parts.push(`Domain=${place.hostname.split(".").slice(-2).join(".")}`);
    }
    parts.push("Path=/", `Max-Age=${ONE_YEAR_SECONDS}`, "SameSite=Lax");
    if (place.protocol === "https:")
        parts.push("Secure");
    return parts.join("; ");
}
export function readLanguageCookie(cookie) {
    for (const entry of cookie.split(";")) {
        const separator = entry.indexOf("=");
        if (separator < 0 || entry.slice(0, separator).trim() !== LANGUAGE_COOKIE)
            continue;
        try {
            return decodeURIComponent(entry.slice(separator + 1).trim());
        }
        catch {
            return undefined;
        }
    }
    return undefined;
}
function browserSources() {
    return {
        cookie: typeof document === "undefined" ? "" : document.cookie,
        languages: typeof navigator === "undefined" ? [] : navigator.languages ?? [navigator.language],
    };
}
/** The `tikl` cookie, then the browser's languages in order, then English. Never writes the cookie. */
export function resolveLanguage(sources = browserSources()) {
    const candidates = [readLanguageCookie(sources.cookie), ...sources.languages];
    for (const candidate of candidates) {
        const match = matchLanguage(candidate);
        if (match)
            return match;
    }
    return "en";
}
//# sourceMappingURL=cookie.js.map